import Choices from 'choices.js'

const initChoices = () => {
  const choiceSelects = document.querySelectorAll('select[data-choices]')

  for(let i = 0; i < choiceSelects.length; i++) {
    const element = choiceSelects[i]

    const searchPlaceholderValue = element.dataset.choicesSearchPlaceholderValue || ''
    const noResultsText = element.dataset.choicesNoResultsText || ''
    const noChoicesText = element.dataset.choicesNoChoicesText || ''
    const itemSelectText = element.dataset.choicesItemSelectText || ''

    new Choices(element, {
      itemSelectText: '',
      searchPlaceholderValue: searchPlaceholderValue,
      noResultsText: noResultsText,
      noChoicesText: noChoicesText,
      itemSelectText: itemSelectText,
    })
  }

  const soilSamplesFilterLocationSelect = document.querySelector("#q_soil_sample_location_country_eq")
  const soilSamplesFilterStateSelect = document.querySelector("#q_soil_sample_location_state_eq")

  if (soilSamplesFilterLocationSelect != undefined) {

    const soilSamplesFilterStateSelectOptions = soilSamplesFilterStateSelect.querySelectorAll("option")
    let allOptions = []

    if (soilSamplesFilterStateSelectOptions != undefined) {
      allOptions = [...soilSamplesFilterStateSelectOptions]
    }

    soilSamplesFilterLocationSelect.addEventListener("change", (e) => {
      for (let i = 0; i < allOptions.length; i++) {
        const option = allOptions[i]
        soilSamplesFilterStateSelect.appendChild(option)
      }

      if(e.target.value != "") {
        for (let i = 0; i < allOptions.length; i++) {
          const option = allOptions[i]
          if (option.dataset.country !== e.target.value.toLowerCase() && option.dataset.country != undefined) {
            option.remove()
          }
        }
      }
    })
  }
}

export default initChoices
